import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import * as moment from 'moment';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import Datepicker from 'src/modules/commons/datepicker/Datepicker.component';

interface EnterpriseInformationFormComponentProps {
  formData: JuridicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean | moment.Moment) => void;
}

class EnterpriseInformationFormComponent extends React.Component<EnterpriseInformationFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question444"
        >
          <div className="icon-title">
            <img
              style={{height: '21px', width: '20px'}}
              alt="Euro"
              className="icon"
              src="/img/building-big-inactive.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Información de la sociedad
              </strong>
              <span className="d-arrow-up"/>
            </h4>
            <div className="gap-20"/>
          </div>
        </div>
        <div
          id="question444"
          className="collapse"
        >
          <div className="gap-20"/>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="gap-20"/>
              <div className="md-input">
                <InputContainer
                  label="Nombre de la sociedad"
                  type="text"
                  value={this.props.formData.enterpriseName || ''}
                  onChange={(value) => this.props.handleChange('enterpriseName')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="gap-20"/>
              <div className="md-input">
                <InputContainer
                  label="Domicilio social"
                  type="text"
                  value={this.props.formData.officeAddress || ''}
                  onChange={(value) => this.props.handleChange('officeAddress')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4 date-group">
              <Datepicker 
                label="Fecha de constitución de la sociedad"
                required={true}
                value={this.props.formData.establishmentDate}
                handleChange={this.props.handleChange('establishmentDate')}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Nombre del notario"
                  type="text"
                  required={true}
                  value={
                    this.props.formData.notaryName ?
                      this.props.formData.notaryName :
                      ''
                  }
                  onChange={(value) => this.props.handleChange('notaryName')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div
                className="md-input"
                data-container="body"
                data-html="true"
                data-trigger="hover"
                data-toggle="popover"
                data-placement="bottom"
                data-content={this.getTooltip()}
              >
                <InputContainer
                  label="Sede del notario"
                  type="text"
                  required={true}
                  value={
                    this.props.formData.notaryAddress ?
                      this.props.formData.notaryAddress :
                      ''
                  }
                  onChange={(value) => this.props.handleChange('notaryAddress')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Número de protocolo"
                  type="text"
                  required={true}
                  value={this.props.formData.protocolNumber ? this.props.formData.protocolNumber : ''}
                  onChange={(value) => this.props.handleChange('protocolNumber')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="padding-20">
              <span>
                En el notario {this.props.formData.notaryName ?
                this.props.formData.notaryName : 'XXXX'} de la provincia&nbsp;
                {this.props.formData.notaryAddress ?
                  this.props.formData.notaryAddress : 'XXXX'} bajo el número de protocolo&nbsp;
                {this.props.formData.protocolNumber ? this.props.formData.protocolNumber : 'XXXX'}
                </span>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="CIF"
                  type="text"
                  required={true}
                  value={this.props.formData.cifNumber ? this.props.formData.cifNumber : ''}
                  onChange={(value) => this.props.handleChange('cifNumber')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Provincia del registro mercantil"
                  type="text"
                  required={true}
                  value={this.props.formData.provinceCommercialRegister ?
                    this.props.formData.provinceCommercialRegister : ''}
                  onChange={(value) => this.props.handleChange('provinceCommercialRegister')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Email de empresa"
                  type="text"
                  required={true}
                  value={this.props.formData.corporateEmail ? this.props.formData.corporateEmail : ''}
                  onChange={(value) => this.props.handleChange('corporateEmail')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="gap-20"/>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Número de tomo"
                  type="text"
                  required={true}
                  value={this.props.formData.volumeNumber ? this.props.formData.volumeNumber : ''}
                  onChange={(value) => this.props.handleChange('volumeNumber')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Número de folio"
                  type="text"
                  required={true}
                  value={this.props.formData.pageNumber ? this.props.formData.pageNumber : ''}
                  onChange={(value) => this.props.handleChange('pageNumber')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Número de hoja"
                  type="text"
                  required={true}
                  value={this.props.formData.sheetNumber ? this.props.formData.sheetNumber : ''}
                  onChange={(value) => this.props.handleChange('sheetNumber')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="gap-20"/>
            <div className="padding-20">
              <span>
                Bajo el tomo {this.props.formData.volumeNumber ? this.props.formData.volumeNumber : 'XXXX'},
                folio {this.props.formData.pageNumber ? this.props.formData.pageNumber : 'XXXX'} y hoja&nbsp;
                {this.props.formData.sheetNumber ? this.props.formData.sheetNumber : 'XX-XXXX'}</span>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Cargo de poderes"
                  type="text"
                  required={true}
                  value={this.props.formData.companyProxy ? this.props.formData.companyProxy : ''}
                  onChange={(value) => this.props.handleChange('companyProxy')(value)}
                />
              </div>
            </div>
            <div className="gap-20"/>
            <label className="switch">
              <input
                type="checkbox"
                checked={this.props.formData.companyProxyIncluded ? this.props.formData.companyProxyIncluded : false}
                onChange={(checked) => this.props.handleChange('companyProxyIncluded')(!checked)}
              />
              <span className="slider round"/>
            </label>
            <span className="switch-text">¿El cargo de poderes está en la constitución de la sociedad?</span>
            <div className="gap-20"/>
          </div>
          {!this.props.formData.companyProxyIncluded ?
            <div>
              <div className="row">
                <p className="padding-20">
                  <strong>
                    Otorgación de poder
                  </strong>
                </p>
                <div className="gap-20"/>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-4 date-group">
                  <Datepicker 
                    label="Fecha de constitución de la sociedad"
                    required={true}
                    value={this.props.formData.establishmentRepresentativeDate}
                    handleChange={this.props.handleChange('establishmentRepresentativeDate')}
                  />
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="gap-20"/>
                  <div className="md-input">
                    <InputContainer
                      label="Provincia de escritura"
                      type="text"
                      value={this.props.formData.provinceDeed || ''}
                      onChange={(value) => this.props.handleChange('provinceDeed')(value)}
                      required={true}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="gap-20"/>
                  <div className="md-input">
                    <InputContainer
                      label="Nombre del notario"
                      type="text"
                      value={this.props.formData.notaryProxyName || ''}
                      onChange={(value) => this.props.handleChange('notaryProxyName')(value)}
                      required={true}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-4">
                  <div className="gap-20"/>
                  <div className="md-input">
                    <InputContainer
                      label="Número de protocolo"
                      type="text"
                      value={this.props.formData.protocolProxyNumber || ''}
                      onChange={(value) => this.props.handleChange('protocolProxyNumber')(value)}
                      required={true}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <div className="row">
                <div className="padding-20">
              <span>
                Escritura de poder otorgada el día {this.props.formData.establishmentRepresentativeDate ?
                this.props.formData.establishmentRepresentativeDate.date().toString(10) : 'DD'} del mes&nbsp;
                {this.props.formData.establishmentRepresentativeDate ?
                  (this.props.formData.establishmentRepresentativeDate.month() + 1).toString(10) : 'MM'} y año&nbsp;
                {this.props.formData.establishmentRepresentativeDate ?
                  this.props.formData.establishmentRepresentativeDate.year().toString(10) : 'AAAA'}&nbsp;con el
                notario&nbsp;
                {this.props.formData.notaryProxyName ?
                  this.props.formData.notaryProxyName : 'XXXX'} y el número de protocolo&nbsp;
                {this.props.formData.protocolProxyNumber ? this.props.formData.protocolProxyNumber : 'XXXX'}
                </span>
                  <div className="gap-20"/>
                </div>
              </div>
            </div>
            : null
          }
          <div className="gap-20"/>
        </div>
      </section>
    );
  }

  private getTooltip(): string {
    return `
      <p>En este mail recibirás todo lo referente a tus inversiones</p>
    `;
  }
}

export default EnterpriseInformationFormComponent;



// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/EnterpriseInformationForm.component.tsx